import { Component, OnInit } from '@angular/core'
import { MenuService } from 'app/services/menu.service'
import { CookieService } from 'ngx-cookie-service'

@Component({
  selector: 'app-negotiations',
  templateUrl: './negotiationsajiles.component.html',
  styleUrls: ['./negotiationsajiles.component.scss']
})
export class NegotiationsajilesComponent implements OnInit {
  url

  constructor(private menuService: MenuService,
    private cookies: CookieService) {}

  ngOnInit() {
    this.url = this.menuService.getScreen('NEGVAJILES', true).url + this.cookies.get('at') + '&mode='+(localStorage.getItem('theme') == 'grey' ? 'light' : 'dark')
  }
}
